import { useMemo } from 'react';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { getSortComparator } from 'utils';

export default function useQuestionSubjects(questionSubjects: string[] = []) {
  const sortedQuestionSubjects = useMemo(
    () =>
      questionSubjects.sort((a, b) =>
        getSortComparator(a.toLowerCase(), b.toLowerCase()),
      ),
    [questionSubjects],
  );

  const createSelectOptions = useCreateSelectOptions();

  const questionSubjectsOptions = useMemo(
    () => createSelectOptions(sortedQuestionSubjects),
    [createSelectOptions, sortedQuestionSubjects],
  );

  return { sortedQuestionSubjects, questionSubjectsOptions };
}
